import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  OptionsNgxOwCarouselService,
  LocalDeviceDetectorService,
} from 'dmmp-services'
import { CarouselComponent } from 'ngx-owl-carousel-o'

@Component({
  selector: 'dmmp-article-topics',
  templateUrl: './article-topics.component.html',
})
export class ArticleTopicsComponent implements OnInit {
  @Input() module: any
  @Input() identifier: string
  @Output() redirectPage = new EventEmitter()
  @ViewChild('owl') carousel: CarouselComponent
  configCarousel: object
  allVocabularies = []

  constructor(
    private options: OptionsNgxOwCarouselService,
    public deviceDetector: LocalDeviceDetectorService
  ) {}

  ngOnInit(): void {
    this.configCarousel = this.options.configurationBenefits(this.module || {})
    this.getAllTerms()
  }

  getAllTerms(): void {
    if (this.module?.vocabularies && this.module?.vocabularies?.length > 0) {
      this.module?.vocabularies?.forEach((item) => {
        if (item?.vocabulary?.terms && item?.vocabulary?.terms?.length > 0) {
          item?.vocabulary?.terms?.forEach((term) => {
            this.allVocabularies.push(term)
          })
        }
      })
    }
  }
}
